import React from "react";
import { Text, Stack } from "@bookingcom/bui-react";
import styles from "./styles.module.css";
export const TimelineLegLocation = ({ date, time, iata, name, spacer = " · ", className, attributes, timestampAttributes, airportAttributes }) => {
    return (React.createElement(Stack, { gap: 0.5, className: className, attributes: attributes },
        React.createElement(Text, { variant: "small_1", className: styles.timestamp, attributes: timestampAttributes }, [date, time].filter(Boolean).join(spacer)),
        React.createElement(Text, { variant: "strong_2", attributes: airportAttributes }, [iata, name].filter(Boolean).join(spacer))));
};
